/*
==============================
_Swiper logic & classes
==============================
*/
// _Swiper Object
var _Swiper = function(id) {
    /*
    ---------------
    Public variables
    ---------------
    */

    this.params = {
        // DEFAULT swiper params
        preventClicks                : false,
        preventClicksPropagation     : false,
        resistanceRatio              : 0.5,
        roundLengths                 : true,
        centeredSlides               : true,
        paginationClickable          : true,
        breakpoints                  : {},
        // Custom params
        lockSwiper                   : false,
        destroySwiper                : false,
        slideToIndex                 : 0,
        autoplayDisableOnInteraction : false
    };

    this.status = 'toAdd';

    /*
    ---------------
    Public events
    ---------------
    */

    // Swiper instantiated, setup everything
    this.onReady = function() {
        $swiper = $('#' + id);
        initSwiperParams();
        this.onUpdate();
    };

    this.onResize = function() {
        this.onUpdate();
    };

    this.onUpdate = function() {
        var mediaParams = getMediaParams();

        if (mediaParams.destroySwiper && this.status != 'destroyed') this.status = 'toDestroy';
        else if (!mediaParams.destroySwiper && (this.status == 'destroyed' || this.status == 'toDestroy')) this.status = 'toAdd';

        switch (this.status) {
            case 'toAdd':
                addSwiper(mediaParams);
                break;
            case 'toUpdate':
                updateSwiper(mediaParams);
                break;
            case 'toDestroy':
                destroySwiper(mediaParams);
                break;
        }
    };

    /*
    ---------------
    Private variables & functions
    ---------------
    */

    var th = this,
        listid = false,
        $swiper,
        swiper,
        // Set params object values
        initSwiperParams = function() {
            // Get breakpoints params
            var mobileData = getMediaData('swiper-mobile'),
                tabletData = getMediaData('swiper-tablet'),
                desktopData = getMediaData('swiper-desktop'),
                sParams = (new _Swiper()).params;

            // Params for all (desktop)
            th.params = $.extend({}, sParams, desktopData);

            // Remove breakpoints from object
            delete sParams.breakpoints;

            // <= Tablet params
            th.params.breakpoints[media.tablet] = $.extend({}, sParams, desktopData, tabletData);

            // <= Mobile params
            th.params.breakpoints[media.mobile] = $.extend({}, sParams, desktopData, tabletData, mobileData);
        },

        replicateLoopInIE = function(mediaParams) {
            var toNextFn = swiper.slideNext.bind(swiper);
            var loop = setInterval(toNextFn,mediaParams.autoplay);

            // remove the internal swiper timeout
            swiper.autoplayTimeoutId && clearTimeout(swiper.autoplayTimeoutId);

            // reset the timer on slide change (pagintation, clicks, etc)
            swiper.on('slideChangeStart', function() {
                clearInterval(loop);
                loop = setInterval(toNextFn, mediaParams.autoplay);
            });
        },

        // Add swiper to the HTML
        addSwiper = function(mediaParams) {
            swiper = new Swiper('#' + id + ' .swiper-container', th.params);
            listid = _Swipers.list.length - 1;
            th.status = 'toUpdate';
            th.onUpdate();
            swiper.on('onSlideChangeStart', slideChanged);

            if (document.documentMode < 10) {
                // the issue is that slidePrev() and slideNext() return fast
                // if `swiper.animating` is true, but IE9 does not support
                // animations, so the `transitionend` and `animationend`
                // events that should trigger the flag off don't fire, so
                // animating is always `true`
                //
                // the fix is to replace it if a nonwritable nonconfigurable
                // version set to false
                Object.defineProperty(swiper, 'animating', {
                    configurable: false,
                    enumerable: true,
                    writable: false,
                    value: false
                });

                // we need to do the same with `swiper.autoplaying' for the
                // autoplay loop to work
                Object.defineProperty(swiper, 'autoplaying', {
                    configurable: false,
                    enumerable: true,
                    writable: false,
                    value: false
                });

                // the loop is still not working properly, replicate with
                // setInterval
                replicateLoopInIE(mediaParams);
            }
        },

        // Update Swiper's params & status
        updateSwiper = function(mediaParams) {
            $swiper.removeClass('swiper-updated');

            var slideIndex = getSlideToIndex(mediaParams.slideToIndex);

            // Lock/Unlock swipes
            if (mediaParams.lockSwiper) {
                swiper.slideTo(0);
                swiper.lockSwipes();
                //$swiper.find('.swiper-wrapper, .swiper-wrapper .swiper-slide').removeAttr('style');
                $swiper.find('.swiper-slide-duplicate').remove();
            }
            else swiper.unlockSwipes();

            // Slide to certain index
            if (slideIndex) swiper.slideTo(slideIndex);

            // Run global onResize
            setTimeout(function() {
                onGlobalResize();
                $swiper.addClass('swiper-updated');
            }, 100);
        },

        // Destroy swiper
        destroySwiper = function() {
            if (swiper) {
                swiper.destroy();
                // $swiper.find('.swiper-wrapper, .swiper-slide').removeAttr('style');
                $swiper.find('.swiper-slide-active').removeClass('swiper-slide-active');
            }
            th.status = 'destroyed';
        },

        // Get the index of the slide we want to see
        getSlideToIndex = function(indexType) {
            var slidesNum = $swiper.find('.swiper-slide').length,
                slideActive = $swiper.find('.swiper-slide-active').index();

            switch (indexType) {
                case "middle":
                    return (slidesNum%2 === 0) ? (slidesNum/2 - 0.5) : slidesNum/2;
                case "active":
                    return slideActive;
                default:
                    return (indexType) ? indexType : false;
            }
        },

        // Get data from HTML
        getMediaData = function(data) {
            data = $swiper.data(data);
            return (data) ? data : {};
        },

        // Get params depending on window size
        getMediaParams = function() {
            if (window.innerWidth > media.tablet) {
                return th.params;
            }
            else if (window.innerWidth > media.mobile) {
                return th.params.breakpoints[media.tablet];
            }
            else {
                return th.params.breakpoints[media.mobile];
            }
        },

        // Events
        slideChanged = function(swiper) {
            var $iframe = $swiper.find('.swiper-slide-active iframe');

            // the iframe must be sameOrigin, and the node ust be there
            // at the BEGINNING of the slide change
            if ($iframe && $iframe.length && $iframe.attr('id')) {
                $iframe.get(0).contentDocument.location.reload(true);
            }
        };
};

// _Swipers Object
var _Swipers = {
    selector: '.swiper',
    list: [],
    onReady: function() {
        var $swipers = $('.swiper');
        for (var i = 0; i < $swipers.length; i++) {
            var swiper = new _Swiper($swipers.eq(i).attr('id'));
            swiper.onReady();
            _Swipers.list.push(swiper);
        }
    },
    onResize: function() {
        for (var i = 0; i < _Swipers.list.length; i++) {
            _Swipers.list[i].onResize();
        }
    }
};

// Initialize everything
$(function() {
    var timer_resize;

    if ($('.swiper').length > 0) {
        _Swipers.onReady();

        $(window).on('resize', function() {
            clearTimeout(timer_resize);
            timer_resize = setTimeout(_Swipers.onResize, 150);
        });
    }
});


if ($(".swiper").length > 0 ){
    $(".swiper").trigger("click");
};